import { gql } from '@apollo/client';
import {
  REPORT_NODE_FRAGMENT,
  NODE_LAYOUT_SETTINGS_FRAGMENT,
} from './reportFragments.graphql';

export const CREATE_REPORT_TEMPLATE_NODE = gql`
  mutation ReportTemplateNodeCreate($input: ReportTemplateNodeCreateInput!) {
    reportTemplateNodeCreate(input: $input) {
      reportTemplateNode {
        ...ReportNode
      }
      errors {
        message
      }
    }
  }
  ${REPORT_NODE_FRAGMENT}
`;

export const DELETE_REPORT_TEMPLATE = gql`
  mutation ReportTemplateDelete($input: ReportTemplateDeleteInput!) {
    reportTemplateDelete(input: $input) {
      deletedId
      errors {
        message
      }
    }
  }
`;

export const DELETE_REPORT_TEMPLATE_NODE = gql`
  mutation ReportTemplateNodeDelete($input: ReportTemplateNodeDeleteInput!) {
    reportTemplateNodeDelete(input: $input) {
      reportTemplateNode {
        ...ReportNode
      }
      errors {
        message
      }
    }
  }
  ${REPORT_NODE_FRAGMENT}
`;

export const UPDATE_REPORT_TEMPLATE = gql`
  mutation ReportTemplateUpdate($input: ReportTemplateUpdateInput!) {
    reportTemplateUpdate(input: $input) {
      reportTemplate {
        id
        title
        templateDescription
      }
      errors {
        message
      }
    }
  }
`;

export const UPDATE_REPORT_TEMPLATE_COVER_PAGE_SETTINGS = gql`
  mutation ReportTemplateNodeLayoutSettingUpdate(
    $input: ReportTemplateNodeLayoutSettingsUpdateInput!
  ) {
    reportTemplateNodeLayoutSettingUpdate(input: $input) {
      nodeLayoutSetting {
        __typename
        id
        layout {
          __typename
          id
        }
        settings {
          __typename
          ... on NodeLayoutCoverPageSetting {
            id
            showProjectAddress
            showCompanyName
            showCompanyLogo
            showDateCreated
            showCreatorName
            showPhotoCount
            showCoverPhoto
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const UPDATE_REPORT_TEMPLATE_NODE = gql`
  mutation ReportTemplateNodeUpdate($input: ReportTemplateNodeUpdateInput!) {
    reportTemplateNodeUpdate(input: $input) {
      reportTemplateNode {
        ...ReportNode
      }
      errors {
        message
      }
    }
  }
  ${REPORT_NODE_FRAGMENT}
`;

export const UPDATE_REPORT_TEMPLATE_NODE_POSITION_BULK = gql`
  mutation ReportTemplateNodeUpdatePositionInBulk(
    $input: ReportTemplateNodeUpdatePositionInBulkInput!
  ) {
    reportTemplateNodeUpdatePositionInBulk(input: $input) {
      reportTemplateNodes {
        nodes {
          ...ReportNode
        }
      }
      errors {
        message
      }
    }
  }
  ${REPORT_NODE_FRAGMENT}
`;

export const UPDATE_REPORT_TEMPLATE_SETTINGS = gql`
  mutation ReportTemplateSettingsUpdate(
    $input: ReportTemplateSettingsUpdateInput!
  ) {
    reportTemplateSettingsUpdate(input: $input) {
      reportTemplateSettings {
        __typename
        id
        showPhotoNumber
        showPhotoCreator
        showPhotoCapturedAt
        showPhotoLocation
        showPhotoTags
        showSectionSummary
      }
      errors {
        message
      }
    }
  }
`;

export const UPDATE_REPORT_TEMPLATE_ASSET_SECTION_SETTINGS = gql`
  mutation ReportTemplateNodeLayoutSettingUpdate(
    $input: ReportTemplateNodeLayoutSettingsUpdateInput!
  ) {
    reportTemplateNodeLayoutSettingUpdate(input: $input) {
      nodeLayoutSetting {
        __typename
        id
        layout {
          __typename
          id
        }
        settings {
          __typename
          ... on NodeLayoutAssetSectionSetting {
            id
            leftHeader
            centerHeader
            rightHeader
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_REPORT_TEMPLATES = gql`
  query GetReportTemplates($first: Int, $after: String) {
    viewer {
      id
      reportTemplates(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            __typename
            id
            title
            templateDescription
            lastUsed
            createdAt
            reportTemplateSettings {
              id
              showPhotoCapturedAt
              showPhotoCreator
              showPhotoLocation
              showPhotoNumber
              showPhotoTags
              showSectionSummary
            }
            reportNodes {
              nodes {
                ...ReportNode
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
            ...NodeLayoutSettings
          }
        }
      }
    }
  }
  ${REPORT_NODE_FRAGMENT}
  ${NODE_LAYOUT_SETTINGS_FRAGMENT}
`;
